import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
  }
};

export default Controller;
